import { render, staticRenderFns } from "./OrdenProduccionHome.vue?vue&type=template&id=30bd5437&scoped=true&"
import script from "./OrdenProduccionHome.vue?vue&type=script&lang=js&"
export * from "./OrdenProduccionHome.vue?vue&type=script&lang=js&"
import style0 from "./OrdenProduccionHome.vue?vue&type=style&index=0&id=30bd5437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd5437",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VProgressCircular,VRow,VSimpleTable})
